import React from "react"
import { Global } from "@emotion/core"
import { Fragment } from "react"
import {
  Configure,
  SearchBox,
  Stats,
  RefinementList,
  InfiniteHits,
  ToggleRefinement,
} from "react-instantsearch-dom"
import { getTheme } from "gatsby-interface"
import { css } from "@emotion/core"
import { Result } from "./Result"
import { AlgoliaSvg } from "./AlgoliaSvg"
const { space } = getTheme()

const searchInputHeight = `3rem`
const searchInputWrapperMargin = space[7]

/* stylelint-disable */
const searchBoxStyles = t => css`
  .ais-InstantSearch__root {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .ais-InstantSearch__root div:nth-of-type(2) {
    height: 100%;
  }
  .ais-SearchBox-input:valid ~ .ais-SearchBox-reset {
    display: block;
  }
  .ais-SearchBox {
    display: inline-block;
    position: relative;
    margin: 0;
    width: 100%;
    height: auto;
    white-space: nowrap;
    box-sizing: border-box;
  }
  .ais-SearchBox-form {
    height: calc(${searchInputHeight} + ${searchInputWrapperMargin});
    display: flex;
    align-items: flex-end;
    margin-bottom: 0;
  }
  .ais-SearchBox-input {
    appearance: none;
    -webkit-appearance: none;
    background: ${t.colors.primaryBackground};
    box-shadow: ${t.shadows.raised};
    border-radius: ${t.radii[3]};
    border: 1px solid ${t.colors.grey[10]};
    color: ${t.colors.text.primary};
    display: inline-block;
    height: ${searchInputHeight};
    padding: 0;
    padding-right: ${searchInputHeight};
    padding-left: ${searchInputHeight};
    margin: 0 ${t.space[7]};
    transition: box-shadow ${t.transitions.speed.default}
        ${t.transitions.curve.default},
      outline ${t.transitions.speed.default} ${t.transitions.curve.default};
    vertical-align: middle;
    white-space: normal;
    width: calc(100% - 2rem);

    :active,
    :focus {
      box-shadow: 0 0 0 2px ${t.colors.purple[30]};
    }
    ::placeholder {
      color: ${t.colors.grey[60]};
    }
  }
  .ais-SearchBox-submit,
  .ais-SearchBox-reset {
    position: absolute;
    margin: 0;
    border: 0;
    background-color: transparent;
    padding: 0;
    cursor: pointer;
    width: ${searchInputHeight};
    height: ${searchInputHeight};
    text-align: center;
    font-size: inherit;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .ais-SearchBox-submit {
    top: ${searchInputWrapperMargin};
    right: inherit;
    left: ${searchInputWrapperMargin};
    border-radius: ${t.radii[2]} 0 0 ${t.radii[2]};
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .ais-SearchBox-submit:focus svg {
    fill: ${t.colors.lilac};
  }
  .ais-SearchBox-submit svg {
    width: ${t.space[5]};
    height: ${t.space[5]};
    fill: ${t.colors.grey[60]};
  }
  .ais-SearchBox-reset {
    display: none;
    top: ${searchInputWrapperMargin};
    left: auto;
    right: ${searchInputWrapperMargin};
    font-size: inherit;
  }
  .ais-SearchBox-reset:hover svg,
  .ais-SearchBox-reset:focus svg {
    fill: ${t.colors.gatsby};
  }
  .ais-SearchBox-reset svg {
    fill: ${t.colors.grey[60]};
    width: ${t.space[4]};
    height: ${t.space[4]};
    vertical-align: middle;
  }
  .ais-SearchBox-input:valid ~ .ais-SearchBox-reset {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .ais-InfiniteHits-list {
    display: grid;
    grid-gap: ${t.space[5]};
    list-style: none;
    margin: 0;
    padding: ${t.space[7]};
  }
  .ais-InfiniteHits-item {
    margin: 0;
    padding: 0;
  }
  .ais-InfiniteHits-loadMore {
    background-color: ${t.colors.white};
    border: 1px solid ${t.colors.gatsby};
    border-radius: ${t.radii[2]};
    color: ${t.colors.gatsby};
    cursor: pointer;
    width: calc(100% - (${t.space[7]} * 2));
    margin: ${t.space[7]};
    height: ${t.space[10]};
    transition: ${t.transitions.default};
    font-weight: bold;
  }
  .ais-InfiniteHits-loadMore:hover,
  .ais-InfiniteHits-loadMore:focus {
    background-color: ${t.colors.gatsby};
    color: ${t.colors.white};
  }
  .ais-InfiniteHits-loadMore[disabled] {
    display: none;
  }
`
/* stylelint-enable */

const searchContextCss = theme => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  padding: `${theme.space[3]} 0`,
  margin: `0 ${theme.space[7]}`,
  borderBottom: `1px solid ${theme.colors.grey[20]}`,
  fontSize: theme.fontSizes[0],
  alignItems: "center",
})

const algoliaContentCss = theme => ({
  fontSize: "11px",
  color: theme.colors.grey[40],
  display: "flex",
  alignItems: "center",

  svg: {
    marginLeft: theme.space[2],
  },
})

const resultCss = theme => ({
  fontSize: theme.fontSizes[0],
  color: theme.colors.grey[40],
})

export const Search = ({ pathname, query }) => {
  return (
    <Fragment>
      <div>
        <Global styles={searchBoxStyles} />

        <div id="plugin-searchbar">
          <SearchBox translations={{ placeholder: `Search Gatsby Library` }} />
        </div>

        <div css={{ display: `none` }}>
          <Configure
            analyticsTags={[`gatsby-plugins`]}
            optionalFilters={["owner.name:gatsbyjs"]}
            attributesToRetrieve={[
              `name`,
              `description`,
              `repository`,
              `githubRepo`,
              `downloadsLast30Days`,
              `humanDownloadsLast30Days`,
              `owner`,
            ]}
          />
          <RefinementList
            attribute="keywords"
            transformItems={items =>
              items.map(({ count, ...item }) => {
                return {
                  ...item,
                  count: count || 0,
                }
              })
            }
            defaultRefinement={[`gatsby-component`, `gatsby-plugin`]}
          />
          <ToggleRefinement
            attribute="deprecated"
            value={false}
            label="No deprecated plugins"
            defaultRefinement={true}
          />
        </div>

        <div css={searchContextCss}>
          <Stats
            css={resultCss}
            translations={{
              stats: n => `${n} results`,
            }}
          />

          <span css={algoliaContentCss}>
            Search by{` `}
            <AlgoliaSvg title="Algolia" />
          </span>
        </div>
      </div>

      <div css={{ overflowY: `auto` }}>
        <InfiniteHits
          hitComponent={result => (
            <Result hit={result.hit} pathname={pathname} query={query} />
          )}
        />
      </div>
    </Fragment>
  )
}
